import { jsx as _jsx } from "react/jsx-runtime";
import _ from "lodash";
import { NextSeo } from "next-seo";
const SEO = (props)=>{
    const openGraph = _.pickBy({
        url: props.ogUrl,
        title: props.ogTitle,
        description: props.ogDescription,
        images: _.identity(props.ogImage) ? [
            {
                url: props.ogImage
            }
        ] : undefined
    }, _.identity);
    const transformedProps = _.pickBy({
        title: props.title,
        description: props.description,
        additionalMetaTags: _.identity(props.keywords) ? [
            {
                name: "keywords",
                content: props.keywords
            }
        ] : undefined,
        openGraph: _.isEmpty(openGraph) ? undefined : openGraph
    }, _.identity);
    return /*#__PURE__*/ _jsx(NextSeo, {
        ...transformedProps
    });
};
export default SEO;
